import { Badge, Tabs } from 'antd';
import { RootState } from 'app/store';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUnreadNotiAmount } from '@slice/orderManager.slice';
import styled from 'styled-components';

import ListNotification from './ListNotification';
import NotificationHistory from './NotificationHistory';

const { TabPane } = Tabs;

export default function NotificationPanel() {
  const { t } = useTranslation();

  // Số thông báo real-time (giống badge chuông hiện tại)
  const liveCount = useSelector((state: RootState) => state.orderManager.listNotification?.length ?? 0);

  // Số chưa đọc trong lịch sử: tổng từ server (GetAllUnreadAmount), lấy lại mỗi lần mở bảng thông báo
  const dispatch = useDispatch<any>();
  // TẠM TẮT gọi GetAllUnreadAmount , bật lại thì bỏ comment
  // useEffect(() => {
  //   dispatch(getUnreadNotiAmount());
  // }, []);
  const unreadCount = useSelector((state: RootState) => state.orderManager.notiHistory?.unreadCount ?? 0);

  return (
    <Wrapper className="w-[340px] max-w-[90vw] px-1">
      <Tabs defaultActiveKey="live" size="small" destroyInactiveTabPane>
        <TabPane
          tab={
            <span className="flex items-center gap-1.5">
              {t('Notification.Title')}
              {liveCount > 0 && <Badge size="small" count={liveCount} overflowCount={99} />}
            </span>
          }
          key="live"
        >
          <ListNotification />
        </TabPane>

        <TabPane
          tab={
            <span className="flex items-center gap-1.5">
              {t('Notification.History')}
              {unreadCount > 0 && <Badge size="small" count={unreadCount} overflowCount={99} />}
            </span>
          }
          key="history"
        >
          <NotificationHistory />
        </TabPane>
      </Tabs>
    </Wrapper>
  );
}

// Ép chữ trắng cho dễ nhìn trên nền tối của dropdown + override màu antd Tabs/Empty.
// Nếu theme của bạn có lúc nền sáng, đổi #fff thành ${({ theme }) => theme.colors.text}.
const Wrapper = styled.div`
  color: #fff;

  .ant-tabs,
  .ant-tabs-tab .ant-tabs-tab-btn {
    color: rgba(255, 255, 255, 0.65);
  }
  .ant-tabs-tab:hover .ant-tabs-tab-btn {
    color: #fff;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #fff;
  }
  .ant-tabs-ink-bar {
    background: #fff;
  }
  .ant-tabs-top > .ant-tabs-nav::before {
    border-bottom-color: rgba(255, 255, 255, 0.2);
  }
  /* nội dung bên trong (title, mã đơn, ...) kế thừa màu trắng */
  .ant-tabs-content,
  .ant-tabs-tabpane {
    color: #fff;
  }
  /* text trạng thái rỗng của antd Empty */
  .ant-empty-description {
    color: rgba(255, 255, 255, 0.65);
  }
`;
